import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n-lite';
import { Link } from 'react-router';
import { bindActionCreators } from 'redux';
import { PropTypes } from 'prop-types';
import Logo from '../common/Logo';
import CustomButton from '../common/CustomButton';
import * as accountActions from '../../actions/accountActions';
import * as JwtUtils from '../../services/jwt/jwtService';
import { ROUTES } from '../../const';

const RECOVER_TOKEN = 'recoverToken';

class ResetPassword extends React.Component {
  constructor(props) {
    super(props);
    this.resetPassword = this.resetPassword.bind(this);
    this.setRecoverTokenError = this.setRecoverTokenError.bind(this);
    this.setPasswordValidationError = this.setPasswordValidationError.bind(this);
    this.state = { recoverTokenError: false, passwordValidationError: false };
  }

  static propTypes = {
    location: PropTypes.object,
    accountActions: PropTypes.object
  };

  componentDidMount() {
    const { accountActions, location } = this.props;

    accountActions.setIndexTransition(false);
    let recoverToken = location.query[RECOVER_TOKEN];

    if (!recoverToken) this.setRecoverTokenError();
    else if (JwtUtils.hasExpired(recoverToken)) this.setRecoverTokenError();
  }

  setRecoverTokenError() {
    this.setState({ recoverTokenError: true });
  }

  setPasswordValidationError() {
    this.setState({ passwordValidationError: true });
  }

  checkPasswords() {
    if (this.newPassword.value && this.newPassword.value === this.repeatNewPassword.value) return true;
    this.setPasswordValidationError();
  }

  resetPassword(e) {
    e.preventDefault();

    if (this.checkPasswords()) {
      const { accountActions, location } = this.props;

      accountActions.resetPassword(this.newPassword.value, location.query[RECOVER_TOKEN]);
    }
  }

  renderPasswordValidationError() {
    const { passwordValidationError } = this.state;

    if (!passwordValidationError) return;
    return (
      <div className="error expand large-12 small-12 column text-center">
        <span>{I18n.t('resetPassword.passwordError')}</span>
      </div>
    );
  }

  renderTitle() {
    const { recoverTokenError } = this.state;
    let title = !recoverTokenError ? I18n.t('resetPassword.title') : I18n.t('resetPassword.tokenError');

    return <h4 className="columns medium-12 text-center">{title}</h4>;
  }

  renderPasswordForm() {
    const { passwordValidationError, recoverTokenError } = this.state;
    if (recoverTokenError) return;
    let inputClassName = passwordValidationError ? 'text-center error-input' : 'text-center';

    return (
      <form onSubmit={this.resetPassword}>
        <div
          className="column xlarge-offset-2 xlarge-8 large-offset-3 large-6 medium-offset-2 medium-8 small-12
                    text-center reset-password-form"
        >
          {this.renderPasswordValidationError()}

          <input
            className={inputClassName}
            id="newPassword"
            type="password"
            ref={ref => (this.newPassword = ref)}
            minLength="6"
            placeholder={I18n.t('resetPassword.newPassword')}
            required
          />
          <input
            className={`${inputClassName} no-margin-input`}
            id="repeatNewPassword"
            type="password"
            minLength="6"
            ref={ref => (this.repeatNewPassword = ref)}
            placeholder={I18n.t('resetPassword.repeatNewPassword')}
            required
          />
          <CustomButton id="sendPassMail" className="button secondary small-button" value={I18n.t('common.done')} />
        </div>
      </form>
    );
  }

  render() {
    return (
      <div className="column xlarge-6 large-8 medium-10 small-12 content align-center">
        <div className="row box background-color-opaque background-color-opaque-opacity align-center">
          <div className="row small-12 align-top">
            <div className="column">
              <div className="column small-12 text-center">
                <Logo customCss="logo-opaque" />
              </div>

              {this.renderTitle()}
              {this.renderPasswordForm()}
            </div>
          </div>

          <div className="row align-self-bottom text-center">
            <Link to={ROUTES.LOGIN}>
              <p className="bottom-link"> {I18n.t('common.backToLogin')}</p>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    i18n: state.i18n
  };
}

function mapDispatchToProps(dispatch) {
  return {
    accountActions: bindActionCreators(accountActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);
